<template>
  <div>
    <!-- <top></top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">小猪班纳</div>
          <div class="contentBottom">
            <div>国产运动品牌智慧门店新范式</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:118px">项目背景</div>
      <div class="lineCss"></div>
    </div>
    <!-- start -->
    <!-- start -->
    <div class="productParent marginTop109">
      <div class="productLeft">
        <div class="productRightTitle">
          <div class="titleBox1">
            <!-- <div class="anliTitle">项目背景</div>
            <div class="lineCss1"></div>-->
          </div>
        </div>
        <div
          class="productRightText paddingRight"
        >小猪班纳是一家面向0~15岁都市儿童的国民童装品牌，致力于倡导儿童童装消费的新时尚。作为天猫新零售线下布局中的首个童装品牌，小猪班纳东莞新零售标杆店显得意义重大。在本次的筹备过程中，小猪班纳和天猫进行了多方考察对比，最终数拓的全场景智慧零售理念、及可落地方案，获得了他们的认可。</div>
      </div>
      <div class="productRight">
        <img :src="productLeft1" class="rightImgCss">
      </div>
    </div>
    <!-- end -->

    <div class="grayBox">
      <div class="titleBox" style="margin-top:0;">
        <div class="anliTitle">方案策略</div>
        <div class="lineCss"></div>
      </div>
      <div
        class="grayBoxText"
      >数拓分析童装消费行为逻辑，从面向店外的针对性家长会员引流，到进店后增加儿童顾客留店时长，再到选购时通过产品溯源对购买率的提升。洞察童装消费本质，以智屏赋能门店，帮助小猪班纳增加消费率的同时，提升会员转化与品牌影响力。</div>
      <!-- detailList start -->
      <div class="detailList">
        <div class="detailBox">
          <img :src="detailListIcon1" alt>
          <div class="detailBoxTitle">数拓智屏OS</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon2" alt>
          <div class="detailBoxTitle">第三方系统对接</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon3" alt>
          <div class="detailBoxTitle">第三方硬件兼容</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon4" alt>
          <div class="detailBoxTitle">天猫数据对接</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon5" alt>
          <div class="detailBoxTitle">场景app</div>
        </div>
      </div>
      <!-- detailList end -->
    </div>
    <!-- 场景解析 start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:138px">场景解析</div>
      <div class="lineCss"></div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <img :src="northFace2" alt>
      </div>
      <div class="bottomRight" >
        <div class="bottomRightTitle marginLeft15" >进店-橱窗互动-吸睛引流</div>
        <div
          class="bottomRightText"
        >小猪班纳的玻璃橱窗有5块互动屏幕，它们均搭载了数拓人脸识别传感器，可以快速识别屏前消费者，并匹配会员系统信息，分析会员宝宝的年龄性别后，在屏幕上切换出推荐商品。数拓认为童装的服务对象虽然是儿童，但售卖中的目标则是父母。所以，通过橱窗内的互动屏幕，对店外成年顾客进行会员识别，并推送相关商品。从商业逻辑出发，做到精准引流。</div>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">选购-星辰云货架</div>
        <div
          class="bottomRightText bottomRightTextTwo"
        >分布在货架周围的两个星辰云货架，可通过蓝牙标签来识别周边商品。没有识别到商品时，随机显示店内有货商品，可以点击查看具体详情。当识别到商品时，自动显示该商品详情。因为打通了门店POS系统，每件商品出售后，云货架可以实时更新库存信息，打通线上线下，提升购物体验。</div>
      </div>

      <div class="bottomRight" style="width:50%;">
        <img :src="wanDaContent3" alt>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <img :src="teBuContent5" alt>
      </div>
      <div class="bottomRight" >
        <div class="bottomRightTitle marginLeft15" >优选溯源屏-无人化售卖</div>
        <div
          class="bottomRightText"
        >店铺中岛的主推款旁，装有优选溯源互动屏。拿起喜爱的商品靠近屏幕，屏幕通过蓝牙标签识别后，会自动显示该优选商品的面料、材质的产地和检验证明等安全信息，帮助小猪班纳从源头打消父母们的安全焦虑。</div>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">全店-探针/热区-客流数据统计</div>
        <div
          class="bottomRightText bottomRightTextTwo"
        >店内分布WiFi探针和热区监控，从手机WiFi信号、热区感应两个渠道，实时抓取店内客流情况。哪个时段、哪个区域、男客还是女客多，皆有数据可依。不仅方便了小猪班纳总部远程巡店，还为接下来的营销计划，提供切实可靠的数据。</div>
      </div>

      <div class="bottomRight" style="width:50%;">
        <img :src="piglet5" alt>
      </div>
    </div>
    <!-- 场景解析 end -->

    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/pigletTop.png";
import productLeft1 from "@/assets/images/piglet1.png";

import wanDaContent2 from "@/assets/images/teBuContent1.png";
import wanDaContent3 from "@/assets/images/piglet3.png";
import wanDaContent4 from "@/assets/images/teBuContent3.png";
import detailListIcon1 from "@/assets/images/teBuIcon1.png";
import detailListIcon2 from "@/assets/images/teBuIcon2.png";
import detailListIcon3 from "@/assets/images/teBuIcon3.png";
import detailListIcon4 from "@/assets/images/teBuIcon4.png";
import detailListIcon5 from "@/assets/images/teBuIcon5.png";
import teBuContent5 from "@/assets/images/piglet4.png";
import teBuContent6 from "@/assets/images/teBuContent6.png";
import teBuContent7 from "@/assets/images/teBuContent7.png";
import northFace2 from "@/assets/images/piglet2.png";
import piglet5 from "@/assets/images/piglet5.png";

import Bread from "@/components/bread.vue";

export default {
  name: "CasePiglet",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      northFace2: northFace2,
      teBuContent5: teBuContent5,
      teBuContent6: teBuContent6,
      teBuContent7: teBuContent7,
      toBreadChild: ["案例", "小猪班纳"],
      bgImg: bgImg,
      wanDaContent2: wanDaContent2,
      wanDaContent3: wanDaContent3,
      wanDaContent4: wanDaContent4,
      productLeft1: productLeft1,
      piglet5: piglet5,
      detailListIcon1: detailListIcon1,
      detailListIcon2: detailListIcon2,
      detailListIcon3: detailListIcon3,
      detailListIcon4: detailListIcon4,
      detailListIcon5: detailListIcon5
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 888px;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 3.6rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}
.lineCss1 {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
  margin-bottom: 40px;
}
.lineCssTwo {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}
.titleBox1 {
}
.titleBoxTwo {
  margin-top: 100px;
  width: 80%;
  margin: auto;
}

/* end */
.productParent::after {
  content: "";
  display: block;
  clear: both;
}
.productParent {
  width: 70%;
  margin: auto;
}

.productLeft {
  width: 44%;
  padding-left: 6%;
  float: left;
}

.productLeft img {
  width: 98%;
  max-width: 542px;
}

.productRight {
  width: 46%;
  padding-left: 2%;
  float: left;
}

.productRightTitle {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 2%;
  width: 82%;
}

.productRightText {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 33px;
  margin-top: 30px;
}

.marginTop109 {
  margin-top: 119px;
}

.grayBoxText {
  width: 64%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 68px;
  text-indent: 40px;
}

.grayBox {
  background: rgba(240, 240, 240, 1);
  margin-top: 170px;
  padding-bottom: 68px;
  padding-top: 70px;
}

.detailList {
  display: flex;
  width: 70%;
  margin: auto;
}

.detailBox {
  width: 25%;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 40px;
}

.bottomParent {
  width: 70%;
  margin: auto;
}
.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}
.bottomLeft {
  width: 50%;
  float: left;
  margin-top: 84px;
}
.bottomLeft img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight {
  margin-top: 84px;
  width: 46%;
  float: right;
}
.bottomRightTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  /* margin-top: 6%; */
  padding-left: 10%;
}
.bottomRightText {
  margin-top: 4%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-left:10%;
}
.bottomRightTitleTwo {
}
.bottomRightTextTwo {
  width: 80%;
  margin: auto;
  margin-top: 6%;
}
.paddingRight {
  padding-right: 5%;
}
.rightImgCss {
  width: 100%;
  /* max-width: 618px; */
}
.gapCss {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: center;
  margin-top: 139px;
}
.marginLeft15{
  /* margin-left: 10%; */
}
</style>



// WEBPACK FOOTER //
// src/view/CasePiglet.vue